import { render, staticRenderFns } from "./tennis-statistics.vue?vue&type=template&id=5b4e134e&scoped=true&"
import script from "./tennis-statistics.vue?vue&type=script&lang=js&"
export * from "./tennis-statistics.vue?vue&type=script&lang=js&"
import style0 from "./tennis-statistics.vue?vue&type=style&index=0&id=5b4e134e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e134e",
  null
  
)

export default component.exports